import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import EvidenceCount from './EvidenceCount';
import type { IncidentDrawerDetailScope } from './incidentDrawerDetailTypes';

export function IncidentDrawerDetailStep1({ scope }: { scope: IncidentDrawerDetailScope }) {
  const s = scope as any;
  const snapshotPick = s._bestSnapshotAttachment(s.selectedIncident);
  const snapshotAvailable =
    Boolean(snapshotPick?.filename) ||
    String(s.selectedIncident?.snapshot_status || '').trim().toUpperCase() === 'AVAILABLE' ||
    Boolean(s.selectedIncident?.snapshot_uri);
  return (
    <Box>
      <Box ref={s.drawerStep1Ref} sx={s.stepSectionSx('step1')}>
    <Paper variant="outlined" sx={s.drawerCardSx}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 1.25 }}>
        <Box>
          {!s.groupedReviewMode ? (
            <Typography sx={s.cardLabelSx}>{s.journeyPhaseTitleForStep('step1')} phase</Typography>
          ) : null}
          {s.renderAuditStepHeading(
            'step1',
            'Step 1: Confirm the event',
            s.groupedReviewMode
              ? undefined
              : `Start with the clearest proof from camera ${s.selectedIncident.camera_id || s.selectedIncident.device_id || 'unknown'}.`,
          )}
        </Box>
        <EvidenceCount count={s.evidenceCount} caption={s.evidenceCount > 0 ? 'Evidence captured for review' : 'No attachments yet'} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Button
          size="small"
          variant="outlined"
          disabled={!s.selectedIncident?.incident_id || !!s.drawerBusy}
          onClick={s._refreshSelectedIncident}
        >
          Refresh evidence
        </Button>
        {snapshotAvailable && (
          <Button
            size="small"
            variant="outlined"
            startIcon={<OpenInNewIcon />}
            onClick={async () => {
              try {
                const pick = s._bestSnapshotAttachment(s.selectedIncident);
                const blob =
                  pick?.filename && pick.preferFileEndpoint
                  ? await s.fetchEvidenceFileBlob(s.selectedIncident.incident_id, pick.filename)
                  : await s.fetchLatestSnapshotBlob(s.selectedIncident.incident_id);
                const overlayed = await s._overlaySnapshotBlob(blob, {
                  label: s._humanLabelCompact(s.selectedIncident),
                  ts: String(s.selectedIncident?.created_at || ''),
                  zone_id: s.selectedIncident?.zone_id,
                  camera_id: s.selectedIncident?.camera_id,
                });
                const filename = (pick?.filename || `${s.selectedIncident.incident_id}.jpg`).replace(/\.(png|gif)$/i, '.jpg');
                s.downloadBlob(overlayed, filename);
              } catch {
                // ignore
              }
            }}
          >
            Open Snapshot
          </Button>
        )}
      </Box>
    </Paper>
    {!s.groupedReviewMode ? s.renderStepNavigation('step1') : null}
      </Box>
    </Box>
  );
}
